import { Component } from '@angular/core';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
    selector: 'app-sign-in',
    templateUrl: './sign-in.component.html',
    styleUrls: ['./sign-in.component.scss'],
    standalone: false
})
export class SignInComponent {
  constructor(private authService: AuthService) {}
  
  onLogin() {
    this.authService.login();
  }

  onCreateAccount() {
    console.log('New Account Clicked!');
  }
}
